// src/actions/deleteOutputFile.ts

import axiosInstance from "../utils/axiosInstance";

// const API_BASE_URL = import.meta.env.VITE_API_URL || "";

export const deleteOutputFile = async (
  fileKey: string
): Promise<{ message: string }> => {
  try {
    // Headers automatically handled by axiosInstance
    const response = await axiosInstance.delete(
      `/utility/delete-output-file`,
      { data: { fileKey } } // Send fileKey in the data payload for DELETE
    );
    return response.data; // Expected to include { message }
  } catch (error: any) {
    console.error("Error deleting file:", error.response?.data || error.message);
    throw new Error(
      error.response?.data?.message || "Failed to delete file."
    );
  }
};
